export const radii = {
  none: '0',
  sm: '6px',
  md: '10px',
  lg: '16px',
  xl: '22px',
  pill: '999px',
  full: '50%',
} as const;

export type RadiusToken = keyof typeof radii;
